import { createParams, handleError } from 'api/utils';
import { createRequest } from 'api/request';

export const getLinkToken = async (state, id) => {
  const qStr = createParams({ id });
  return createRequest(`/v1/plaid_link_token${qStr}`, state, {
    method: 'GET',
  }).then((res) => handleError(res));
};
